<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-05-17 17:08:58
 * @LastEditTime: 2021-06-16 16:35:34
 * @LastEditors: JDY
-->
<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/exams/form' }">
        <a-button type="primary" icon="plus">
          添加问卷
        </a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <div class="ant-pro-page-header-search">
          <a-input-search
            size="large"
            style="width: 80%; max-width: 522px;"
            v-model="params.where.title"
            placeholder="请输入名称"
            enter-button
            @search="getLists()"
          />
        </div>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="state" slot-scope="text, record">
          <a-switch :checked="record.state === 1" @change="handleChangeState(text, record.id)" v-action:state>
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">

          <router-link v-action:contents :to="'/exams/contents/' + record.id">
            <a-button type="link" size="small">题库管理</a-button>
          </router-link>
          <router-link v-action:contents :to="'/exams/form/' + record.id">
            <a-button type="link" size="small">编辑</a-button>
          </router-link>
          <a-popconfirm
            title="确定要删除该信息吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleOnDelete(record.id)"
            v-action:delete
          >
            <a-button type="link" size="small">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入

const apiList = {
    getList: '/exams',
    changeState: '/exams/',
    delete: '/exams/',
    selectList: '/exams/type'
}
const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '标题',
        dataIndex: 'title'
    },
    {
        title: '简介',
        dataIndex: 'desc'
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '更新时间',
        dataIndex: 'updated_at',
        sorter: true
    },
    {
        title: '状态',
        dataIndex: 'state',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

export default {
    name: 'ExamList',
    mixins: [list, table, select], // 使用mixins
    components: { },
    data () {
        return {
            apiList,
            selectList: [],
            selectLoad: false,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取列表
        this.getSelectLists({
            url: apiList.selectList,
            type: 'selectList',
            load: 'selectLoad'
        }) // 获取分类下拉
    },
    methods: {

    }
}
</script>
